
import React, { useCallback, useEffect, useState, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { ChevronRight, ChevronDown, Search, Info, Copy, Upload, CheckCircle } from "lucide-react";
import storage from "../../../../Storage";
import C from "../../../../Constant";
import coins from "../../../coins";
import socket from "../../../../Socket";
import { Col, Row, Dropdown } from "react-bootstrap";
import {
  __, wait, decode, encode, forceSatoshiFormat, Event,
  isMobile,
  sendNotfication,
  getUID,
} from '../../../../Helper';
import axios from 'axios';
import { QRCode } from 'react-qrcode-logo';

import { Info as InfoIcon } from 'lucide-react';

// QR Image Component to convert Buffer data to image URL
const QRImageComponent = ({ qrImage, alt = "QR Code" }) => {
  const [imgSrc, setImgSrc] = useState("");

  useEffect(() => {
    if (qrImage?.data && Array.isArray(qrImage.data)) {
      try {
        // Convert Uint8Array to base64
        const base64String = btoa(
          String.fromCharCode(...new Uint8Array(qrImage.data))
        );
        setImgSrc(`data:image/png;base64,${base64String}`);
      } catch (error) {
        console.error('Error converting QR image:', error);
        setImgSrc("");
      }
    }
  }, [qrImage]);

  if (!imgSrc) {
    return <div style={{ color: '#fff', textAlign: 'center' }}>Loading QR Code...</div>;
  }

  return <img src={imgSrc} alt={alt} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />;
};

const Container = styled.div`
  padding: 8px;
  color: #ffffff;
  // background: #1B2326;
   @media (max-width: 768px) {
     padding: 0px;
  }
`;


const DropdownContainer = styled.div`
  position: relative;
  margin-bottom: 8px;
  flex:1;
`;

const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding:6px 10px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  font-size: 16px;
`;

const DropdownPanel = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background:#1B2326;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  margin-top: 4px;
  max-height: 400px;
  overflow-y: auto;
  z-index: 1000;
  padding: 10px 12px;
  
  @media (max-width: 768px) {
    max-height: 300px;
    position: absolute;
    width: 100%;
    z-index: 1001; /* Higher z-index to ensure visibility */
  }
`;

const QRCodeContainer1 = styled.div`
  width: 190px;
  height: 190px;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  padding: -6px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  margin-top: 12px;
  
  @media (max-width: 768px) {
    margin-top: 8px;
    margin-bottom: 8px;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 6px 12px 6px 40px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #ffffff;
  font-size: 16px;
  &::placeholder {
    color: #fff;
    opacity: 0.6;
  }
  
  @media (max-width: 768px) {
    padding: 6px 8px 6px 36px;
    font-size: 14px;
  }
`;

const Input = styled.input`
flex:1;
  padding:6px 10px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  &::placeholder {
    color: #fff;
    opacity:0.6;
  }
`;
const DepositButton = styled.div`
  
  margin-top: auto;
flex:1;
padding:7px 9px;
  display:flex;
  justify-content:center;
  align-items:center;
   background: #FF5C5C;
  color: black !important;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  
  &:hover {
    opacity: 0.9;
  }
`;
const GetButton = styled.div`
  flex:1;
  margin-top: 1px;
  padding: 8px 12px;
  display:flex;
  justify-content:center;
  align-items:center;
   background: #FF5C5C;
  color: black !important;
  border: none;
   border-radius: 8px;
width:100%;
  font-weight: 600;
  cursor: pointer;
  
  &:hover {
    opacity: 0.9;
  }
`;
const SearchIcon = styled.div`
  position: absolute;
  left: 14px;
  top: 49%;
  transform: translateY(-50%);
  color: #fff;
`;

const CoinOption = styled.div`
  display: flex;
  align-items: center;
  padding: 14px;
  cursor: pointer;
  border-radius: 12px;
  &:hover {
    background: rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.1);
  }
  ${props => props.isSelected && `
    background: rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.1);
  `}
  
  @media (max-width: 768px) {
    padding: 10px;
    margin-bottom: 4px;
  }
`;

const CoinImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 12px;
  
  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
`;

const CoinName = styled.div`
  font-size: 16px;
  font-weight: bold;
  
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const CoinName1 = styled.div`
  font-size: 16px;
  font-weight: bold;
   @media (max-width: 768px) {
   margin-left: -16px;
     font-size: 10px;
     text-wrap:no-wrap;
  }
 
`;

const CoinBalance = styled.span`
  margin-left: auto;
  color: #8E9293;
   display:none;
`;


// const CoinName = styled.span`
//   font-size: 16px;
//   font-weight: 500;
// `;

const TokenListContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
    @media (max-width: 768px) {
  gap: 4px;
  margin-top: 4px;
  }
`;

const TokenButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
   background: #1B2326;
  border-radius: 100px;
  border: none;
  cursor: pointer;
  color: #ffffff;
  transition: background 0.2s ease;
  &:hover {
     background: #1B2326;
  }
        @media (max-width: 768px) {
 gap: 4px;
  padding: 4px 8px;
  }
`;

const TokenIcon = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
          @media (max-width: 768px) {
      
width: 18px;
  height: 18px;

  }
  
`;

const TokenName = styled.div`
  font-size: 14px;
  font-weight: 500;
      @media (max-width: 768px) {
   font-size: 12px;
  }
`;

const MoreButton = styled(TokenButton)`
  padding: 8px 12px;
    @media (max-width: 768px) {
    padding: 4px 8px;
  }

`;

const NoteContainer = styled.div`
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px auto 16px;
  border-left: 3px solid #FF9D02;
`;

const NoteText = styled.span`
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
`;

const NoteIcon = styled(Info)`
  color: #FF9D02;
  flex-shrink: 0;
`;

const FooterText = styled.div`
  color: #ffffff;
  margin: 18px 0;
`;

const AddLink = styled.span`
  color: #20EE89;
  cursor: pointer;
`;




const Label = styled.div`
  color: #ffff;
  font-size: 14px;
  
   @media (max-width: 768px) {
    text-align:center;
  }
`;







const CodeContainer = styled.div`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap:4px;
  margin: 12px 0px;
`;
const WarningContainer = styled.div`
   background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;s
  margin: 0 auto;
  margin-bottom: 16px;
`;

const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const WarningText = styled.span`
  color: #ffff;
  font-size: 14px;
  font-weight: 500;
`;

const BonusContainer = styled.div`
  background-color: rgba(180, 155, 100, 0.2);
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 18px auto;
  margin-bottom: 16px;
`;

const IconWrapper1 = styled.div`
  width: 28px;
  height: 28px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
const ImagePlaceholder = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
`;

const rotate = keyframes`
0% { transform: rotate(0deg); }
100% { transform: rotate(360deg); }
`;

const RotatingImage = styled(ImagePlaceholder)`
animation: ${rotate} 6s linear infinite;
`;


const Container1 = styled.div`
  max-width: 400px;
  width: 100%;
`;

const BonusButton = styled.button`
  width: 100%;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 8px;
  text-align: left;
  font-weight: 500;
  transition: background-color 0.2s;
  cursor: pointer;

  &:hover {
    background-color: #f9fafb;
  }
`;

const RadioContainer = styled.div`

  border-radius: 8px;
  display: flex;
  flex-direction:column;
  gap: 6px;
  width:100%;
  margin:12px 0px;
`;

const Label3 = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;
`;

const RadioWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const HiddenRadio = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

const CustomRadio = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #e5e7eb;
  border-radius: 50%;
  transition: all 0.2s;                                    
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  ${HiddenRadio}:checked + & {
    border-color: #41ED84;
  }

  &:after {
    content: '';
    position: absolute;
    display: none;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background-color: #41ED84;
    
    ${HiddenRadio}:checked ~ & {
      display: block;
    }
  }
`;
const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;

const BaseText = styled.span`
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
`;

const HighlightedText = styled(BaseText)`
  color: #FF5C5C;
`;
const Text = styled.span`
  font-weight: 500;
  text-wrap:no-wrap;
`;

const Container5 = styled.div`
  display: flex;
  gap: 16px;
  // padding: 16px;
  border-radius: 8px;
  width: 100%;
  margin:12px 0px;

   @media (max-width: 768px) {
     gap: 6px;
     align-items:center;
  }
  

`;

const QRCodeContainer = styled.div`
 width:100%;
  border-radius: 4px;
  overflow: hidden;
  display:flex;
  align-items:center;
  justify-content:center;
  
  img {
    width: 120px;
  height: 120px;
    object-fit: contain;
  }
`;

const ContentContainer = styled.div`
  flex: 1;
  width: 67%;
  display: flex;
  flex-direction: column;
  gap: 10px;
    @media (max-width: 768px) {
      width: 61%;
  }
`;

const Label4 = styled.div`
  color: #9ba1a6;
  font-size: 14px;

`;

const AddressContainer = styled.div`
  background: rgba(0, 0, 0, 0.2);
  padding: 12px;
  border-radius: 6px;
  width: 100%;
  color: #fff;
  font-family: monospace;
  font-size: 14px;
  width:100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0; // Important for text truncation
    margin-top:-12px;
  }
`;

const CopyButton = styled.div`
  background: rgba(0, 0, 0, 0.35);
  color: #fff;
  border: none;
  // flex:1;
  // width:100%;
  // padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  // margin-right:auto;
  display: flex;
  text-align:center;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  transition: background-color 0.2s;
  white-space: nowrap;
  width: fit-content;
  
  // &:hover {
  //   background-color: #4c5256;
  // }
`;

const CopyIcon = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: currentColor;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z' /%3E%3C/svg%3E");
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
`;




// Add new styled components for the form
const ErrorText = styled.div`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 0px;
`;

const TransactionForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
  width: 100%;
`;

const FileUploadContainer = styled.div`
  border: 2px dashed #41ED84;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  cursor: pointer;
  margin-top: 8px;

  &:hover {
    border-color: #20EE89;
  }
`;

const UploadText = styled.div`
  color: #ffffff;
  margin-top: 8px;
  font-size: 14px;
`;
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;
const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2;
`;

const Spinner = styled.div`
  width: 2rem;
  height: 2rem;
  border: 3px solid #e5e7eb;
  border-top-color: #ab1ac6;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const LoadingText = styled.span`
  color: #ab1ac6;
  font-size: 1rem;
  margin-left: 0.75rem;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;
const PaymentProcessingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(3, 3, 15, 0.95);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  
`;

const ProcessingSpinner = styled.div`
  width: 56px;
  height: 56px;
  border: 4px solid rgba(255, 92, 92, 0.2);
  border-top-color: #FF5C5C;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const ProcessingTitle = styled.div`
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
`;

const ProcessingMessage = styled.div`
  color: #9CA3AF;
  font-size: 14px;
  text-align: center;
  max-width: 320px;
  line-height: 1.6;
  animation: ${pulse} 2s ease-in-out infinite;
`;

const ProcessingDots = styled.span`
  &::after {
    content: '';
    animation: dots 1.5s steps(4, end) infinite;
  }
  @keyframes dots {
    0% { content: ''; }
    25% { content: '.'; }
    50% { content: '..'; }
    75% { content: '...'; }
  }
`;

const PaymentMethodContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  width: 100%;
`;

const MethodSelector = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;


const MethodButton = styled.button`
  flex: 1;
  padding: 12px;
  border-radius: 8px;
  border: 2px solid ${props => props.selected ? '#E5E7EB' : '#FF5C5C'};
  background: ${props => props.selected ? '#FF5C5C' : '#FF5C5C'};
  color: ${props => props.selected ? '#000000' : '#374151'};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.selected ? '#FF5C5C' : '#FF5C5C'};
  }
`;

const BonusCardSectionTitle = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 2px;
  letter-spacing: 1px;
  color: #FF5C5C;
`;

// Container for the transaction form
const TransactionFormContainer = styled.div`
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 24px;
  margin-top: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

// Error message styling
const ErrorMessage = styled.div`
  color: #d32f2f;
  background-color: #ffebee;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 14px;
`;
const CardBG = styled.div`
  background-color: rgb(50, 55, 56);
  border-radius: 12px;
  position: relative;
`;

// Form group for each input field
const FormGroup = styled.div`
  margin-bottom: 20px;
  
  label {
    display: block;
    margin-bottom: a8px;
    font-weight: 500;
    color: #424242;
  }
  
  input {
    width: 100%;
    padding: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 14px;
    
    &:focus {
      outline: none;
      border-color: #2196f3;
      box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
    }
    
    &::placeholder {
      color: #9e9e9e;
    }
  }
`;

// Container for buttons
const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;

// Base button style
const Button = styled.button`
  padding: 12px 24px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
`;

// Submit button
const SubmitButton = styled(Button)`
  background-color: #2196f3;
  color: white;
  border: none;
  
  &:hover {
    background-color: #1976d2;
  }
`;

// Cancel button
const CancelButton = styled(Button)`
  background-color: white;
  color: #616161;
  border: 1px solid #e0e0e0;
  
  &:hover {
    background-color: #f5f5f5;
  }
`;
// Deposit button
const cryptoOptions = [
  { id: 'dot', name: 'DOT', iconClass: 'dot' },
  { id: 'link', name: 'LINK', iconClass: 'link' },
  { id: 'dai', name: 'DAI', iconClass: 'dai' },
  { id: 'usdc', name: 'USDC', iconClass: 'usdc' },
  { id: 'xmr', name: 'XMR', iconClass: 'xmr' },
];

const tokens = [
  { id: 'eth', name: 'ETH', icon: '/assets/images/ETH.png' },
  { id: 'btc', name: 'BTC', icon: '/assets/images/BTC.png' },
  { id: 'usdt', name: 'USDT', icon: '/assets/images/USDT.png' },
  // { id: 'usdc', name: 'USDC', icon: '/assets/images/USDC.png' },
  { id: 'doge', name: 'DOGE', icon: '/assets/images/DOGE.png' },
];

const BonusCardsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: left;
  margin: 18px 0 12px 0;
  @media (max-width: 768px) {
    flex-direction: row;
    gap: 6px;
    align-items: stretch;
  }
`;

const BonusCardContainer = styled.div`
  display: flex;
  // flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #1B2326;
  gap: 10px;
  border: 1px solid transparent;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  // padding: 14px 10px 14px 10px;
  max-width: 200px;
  min-width: 120px;
  min-height: 50px;
  width: 100%;
  position: relative;
  cursor: pointer;
  transition: border 0.2s;
  &.selected {
    border: 1px solid #FF5C5C;
  }
  @media (max-width: 768px) {
    max-width: 48vw;
    min-width: 0;
    padding: 12px;
    min-height: 70px;
  }
`;

const SmallImagePlaceholder = styled.img`
  width: 25px;
  height: 25px;
  object-fit: contain;
  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
  }
`;
const SmallRotatingImage = styled(SmallImagePlaceholder)`
  animation: ${rotate} 6s linear infinite;
`;

const BonusSVGWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-bottom: 2px;
  // margin-top: 2px;
`;

const InfoIconButton = styled.div`
  // position: absolute;
  // top: 12px;
  // right: 16px;
  // background: none;
  // border: none;
  // cursor: pointer;
  // color: #fff;
  // padding: 4px;
  // z-index: 2;
`;

const BonusTypeToggle = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 2px;
  margin-bottom: 2px;
`;

const BonusToggleButton = styled.button`
  padding: 4px 24px;
  border-radius: 8px;
  border: none;
  font-weight: 600;
  font-size: 14px;
  background: ${({ selected }) => (selected ? '#FF5C5C' : '#23272f')};
  color: ${({ selected }) => (selected ? '#23272f' : '#fff')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
  transition: background 0.2s, color 0.2s;
`;

const BonusInfoModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BonusInfoModalContent = styled.div`
  background: #23272f;
  border-radius: 16px;
  padding: 32px 24px 24px 24px;
  max-width: 420px;
  width: 90vw;
  color: #fff;
  position: relative;
`;

const BonusInfoModalClose = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
`;

const BonusCardTitle = styled.div`
  text-align: center;
  margin-bottom: 8px;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.5px;
`;
const BonusCardInfo = styled.div`
  text-align: center;
  margin-bottom: 6px;
  font-size: 13px;
`;
const BonusCardHighlight = styled.span`
  color: #FF5C5C;
  font-weight: 600;
  font-size: 14px;
`;

const SkylaDepositModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenNetwork, setIsOpenNetwork] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedNetwork, setSelctedNetwork] = useState("")
  const [selectedBank, setSelectedBank] = useState("Choose Bank")
  const [error, setError] = useState("");
  const [showTransactionForm, setShowTransactionForm] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [screenshot, setScreenshot] = useState(null);
  const [placeholder, setPlaceholder] = useState("");
  const [bankImage, setBankImage] = useState("");

  const [showCasinoInfo, setShowCasinoInfo] = useState(false);
  const [showSportsInfo, setShowSportsInfo] = useState(false);
  const [selectedBonusCard, setSelectedBonusCard] = useState(null); // 'casino' or 'sports' or null
  // User info state
  const [userInfo, setUserInfo] = useState(null);
  const [customerName, setCustomerName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const cashAppEmails = [
    'user01@yopmail.com', 'user02@yopmail.com', 'user03@yopmail.com', 'user04@yopmail.com',
    'user05@yopmail.com', 'user06@yopmail.com', 'user07@yopmail.com', 'user08@yopmail.com',
    'user09@yopmail.com', 'user10@yopmail.com', 'user11@yopmail.com', 'user12@yopmail.com',
    'user13@yopmail.com', 'user14@yopmail.com', 'user15@yopmail.com', 'user16@yopmail.com',
    'user17@yopmail.com', 'user18@yopmail.com', 'user19@yopmail.com', 'user20@yopmail.com',
  ];
  const [cashAppEmail, setCashAppEmail] = useState(cashAppEmails[Math.floor(Math.random() * cashAppEmails.length)]);
  const [cashAppProductName] = useState('Deposit');
  const [showCashAppForm, setShowCashAppForm] = useState(false);

  // Coin and credit state
  const [credits, setCredits] = useState({});
  const [selectedCoin, setSelectedCoin] = useState("USD");
  const [activeCoins, setActiveCoins] = useState(
    storage.getKey('active_coins')?.split(',').map(String) || ['1']
  );


  const [selectedPayment, setSelectedPayment] = useState("Bank Transfer")

  // Main component state
  const [state, setState] = useState({
    currentCoin: storage.getKey('coin') || "BTC",
    credits: {},
    list: [],
    content: [],
    wallet: "btc",
    deposit: true,
    slide: false,
    height: 573,
    margin: "mt-1",
    amount: "",
    coinId: "",
    networks: [],
    selectedNetwork: "",
    qrString: "",
    coinName: "",
    logoUrl: "",
    isLoading: false,
    isCopied: false,
    depositAddress: "",
    depositAmount: "",
    showDepositDetails: false,
    iframeUrl: '', // New state for iframe URL
    showIframe: false // New state to toggle iframe visibility
  });
  const [phoneNumber, setPhoneNumber] = useState('');
  const [paymentMode, setPaymentMode] = useState('automatic');
  const [bankDetailsList, setBankDetailsList] = useState([]);
  const [selectedBankDetails, setSelectedBankDetails] = useState(null);
  const [selectedUPI, setSelectedUPI] = useState('UPI1');
  const [bankDetails, setBankDetails] = useState([]);
  const [copied, setCopied] = React.useState(false);
  const address = "0x5e6E82fc1117AE06c8b1230164284Ec5d0141Df";
  const [isOpenBonus, setIsOpenBonus] = useState(false);
  const [selectedDeposit, setSelectedDeposit] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('automatic');
  const [copiedStates, setCopiedStates] = useState({
    accountName: false,
    accountNumber: false,
    ifscCode: false
  });

  const deposits = [
    "1st Deposit Bonus",
    "2nd Deposit Bonus",
    "3rd Deposit Bonus",
    "4th Deposit Bonus"
  ];
  const bankDeatils = [
    "Bank Of Maldives",
    "Commercial Bank of Maldives"
  ]
  const getbankImage = (i) => {
    if (i === "Bank Of Maldives") {
      return "/assets/images/bom.png"
    }
    else {
      return "/assets/images/CBM.jpg"
    }
  }

  const paymentDetails = [
    "Bank Transfer",
    "UPI ID",
    "Google Pay"
  ];


  // Fetch bank details when selectedCoin changes (for fiat currencies)
  // useEffect(() => {
  //   if (isFiatCurrency(selectedCoin)) {
  //     fetchBankDetails();
  //   }
  // }, [selectedCoin]);
  useEffect(() => {
    if (selectedCoin === "INR" && paymentMode === "manual") {
      setSelectedBank(""); // Clear selected bank when switching to UPI mode
    } else if (isFiatCurrency(selectedCoin)) {
      fetchBankDetails(); // Fetch bank details for other fiat currencies
    }
  }, [paymentMode, selectedCoin]);

  useEffect(() => {
    if (state.currentCoin === "MVR") {
      setPlaceholder("Enter Deposit Amount (Minmim 100MVR)")
    }
    else {
      setPlaceholder("Enter Deposit Amount")
    }
  }, [state.currentCoin])
  // Function to fetch bank details from API
  // const fetchBankDetails = async () => {
  //   try {
  //     const response = await fetch(`https://api.ibitplay.com/bankDetails/${selectedCoin}`);
  //     if (!response.ok) {
  //       throw new Error('Failed to fetch bank details');
  //     }
  //     const data = await response.json();
  //     setBankDetails(data);

  //     // Set first bank as default if available
  //     if (data.length > 0) {
  //       setSelectedBank(data[0].bank_name);
  //       setSelectedBankDetails({
  //         accountName: data[0].account_holder_name,
  //         accountNumber: data[0].account_number,
  //         ifscCode: data[0].ifsc_code,
  //         upiId: data[0].upi_id
  //       });
  //     }
  //   } catch (error) {
  //     console.error('Error fetching bank details:', error);
  //     setError('Failed to load bank details. Please try again.');
  //   }
  // };

  const getAuthToken = () => {
    return localStorage.getItem('token');
  };
  const fetchBankDetails = async () => {
    try {
      const token = getAuthToken(); // or AsyncStorage.getItem('token')

      const response = await fetch(`https://api.ibitplay.com/bankDetails/${selectedCoin}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch bank details');
      }

      const data = await response.json();
      console.log("data###", data);

      // if(data.length > 0) {
      //   setSelectedBank(data[0].bank_name);
      //   setSelectedBankDetails({
      //     accountName: data[0].account_holder_name,
      //     accountNumber: data[0].account_number,
      //     ifscCode: data[0].ifsc_code,
      //     upiId: data[0].upi_id,
      //     qr_image: data[0].qr_image
      //   });
      //   setBankImage(data[0].qr_image); 
      // }

      if (data.length > 0) {
        console.log("data###2222", data);
        setBankDetails(data);
      }
      else {
        setBankDetails([]);
      }

      // if (selectedCoin === "BDT") {

      //   setBankDetails(data.filter(bank => bank.upi_id));
      // } else {
      //   setBankDetails(data);
      // }

      // if (data.length > 0) {
      //   setSelectedBank(data[0].bank_name);
      //   setSelectedBankDetails({
      //     accountName: data[0].account_holder_name,
      //     accountNumber: data[0].account_number,
      //     ifscCode: data[0].ifsc_code,
      //     upiId: data[0].upi_id,
      //   });
      // }
    } catch (error) {
      console.error('Error fetching bank details:', error);
      setError('Failed to load bank details. Please try again.');
    }
  };




  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setScreenshot(file);
      setError("");
    }
  };

  // Handle bank selection
  const handleBankSelect = (bankName) => {
    setSelectedBank(bankName);
    const bank = bankDetails.find(b => b.bank_name === bankName);
    if (bank) {
      setSelectedBankDetails({
        accountName: bank.account_holder_name,
        accountNumber: bank.account_number,
        ifscCode: bank.ifsc_code,
        upiId: bank.upi_id,
        qr_image: bank.qr_image
      });
      // Set bank image for display
      setBankImage(bank.qr_image);
    }
    setIsOpenNetwork(false);
  };

  // Handle copy functionality
  const handleCopyAddress = (field, value) => {
    navigator.clipboard.writeText(value);
    setCopiedStates(prev => ({
      ...prev,
      [field]: true
    }));

    setTimeout(() => {
      setCopiedStates(prev => ({
        ...prev,
        [field]: false
      }));
    }, 2000);
  };
  useEffect(() => {
    // Reset all form-related states
    setError("");
    setShowTransactionForm(false);
    setTransactionId("");
    setScreenshot(null);
    setState(prev => ({ ...prev, amount: "" }));
  }, [selectedCoin]); // Dependency on selectedCoin


  const renderPayment = () => {
    return (
      <>
        {selectedPayment === "Bank Transfer" && (
          <>
            <AddressContainer>
              <span>Account Holder Name: {bankDetails?.accountName}</span>
              <CopyButton
                onClick={() => handleCopyAdress('accountName', bankDetails?.accountName)}
                copied={copiedStates?.accountName}
              >
                {copiedStates?.accountName ? <CheckCircle size={18} /> : <Copy size={18} />}
                {copiedStates?.accountName ? 'Copied!' : 'Copy'}
              </CopyButton>
            </AddressContainer>
            <AddressContainer>
              <span>Account Number: {bankDetails?.accountNumber}</span>
              <CopyButton
                onClick={() => handleCopyAdress('accountNumber', bankDetails?.accountNumber)}
                copied={copiedStates?.accountNumber}
              >
                {copiedStates?.accountNumber ? <CheckCircle size={18} /> : <Copy size={18} />}
                {copiedStates?.accountNumber ? 'Copied!' : 'Copy'}
              </CopyButton>
            </AddressContainer>
            <AddressContainer>
              <span>IFSC Code: {bankDetails?.ifscCode}</span>
              <CopyButton
                onClick={() => handleCopyAdress('ifscCode', bankDetails?.ifscCode)}
                copied={copiedStates?.ifscCode}
              >
                {copiedStates?.ifscCode ? <CheckCircle size={18} /> : <Copy size={18} />}
                {copiedStates?.ifscCode ? 'Copied!' : 'Copy'}
              </CopyButton>
            </AddressContainer>
          </>
        )}

        {selectedPayment === "UPI Number" && (
          <>
            <AddressContainer>
              <span>UPI Number: 993939393</span>
              <CopyButton
                onClick={() => handleCopyAdress('accountName', 993939393)}
                copied={copiedStates?.accountName}
              >
                {copiedStates?.accountName ? <CheckCircle size={18} /> : <Copy size={18} />}
                {copiedStates?.accountName ? 'Copied!' : 'Copy'}
              </CopyButton>
            </AddressContainer>
          </>
        )}

        {selectedPayment === "UPI ID" && (
          <>
            <AddressContainer>
              <span>UPI Number: 993939393@upi</span>
              <CopyButton
                onClick={() => handleCopyAdress('accountName', '993939393@upi')}
                copied={copiedStates?.accountName}
              >
                {copiedStates?.accountName ? <CheckCircle size={18} /> : <Copy size={18} />}
                {copiedStates?.accountName ? 'Copied!' : 'Copy'}
              </CopyButton>
            </AddressContainer>
          </>
        )}

      </>
    )
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(state.depositAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    sendNotfication("copied", "success", "bottom-left", true);
  };
  const handleCopyAdress = async (field, value) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopiedStates(prev => ({ ...prev, [field]: true }));

      // Reset the copied state after 2 seconds
      setTimeout(() => {
        setCopiedStates(prev => ({ ...prev, [field]: false }));
      }, 2000);
      sendNotfication("copied", "success", "top-right");
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };



  // Utility Functions
  const getCoinNameByNetwork = useCallback((network, coinInfo, defaultCoin) => {
    if (networkCoinMap[network]) {
      return networkCoinMap[network];
    }
    if (coinInfo && coinInfo.id) {
      return coinInfo.id;
    }
    return defaultCoin.toLowerCase();
  }, []);

  // Socket and Credit Management
  const getCreditAndCoins = useCallback((data) => {
    const { credit } = data;
    setState(prev => ({ ...prev, credits: credit }));
    setUpCoins();
  }, []);

  const getTextBonus = (i) => {
    if (i === 0) {
      return '180%'
    }
    else if (i === 1) {
      return '240%'
    }
    else if (i === 2) {
      return '300%'
    }
    else if (i === 3) {
      return '360%'
    }
  }

  const setUpCoins = useCallback(() => {
    if (isMobile()) {
      setState(prev => ({ ...prev, height: 685, margin: "mt-1" }));
    }

    const newList = coins.reduce((acc, item, i) => {
      if (item.preffix === "NC") return acc;

      const credit = forceSatoshiFormat(
        state.credits[__.lowerCase(item.preffix)]
      );

      const listItem = (
        <Dropdown.Item
          key={__.toString(i)}
          as="button"
          className="animated fadeIn"
          onClick={() => loadCoinId(item.preffix)}
        >
          <span>
            <img
              src={`/assets/images/${item.image}`}
              className="mr-1 img-fluid mini-coin"
              alt="Coin"
            />
            {item.preffix}
          </span>
        </Dropdown.Item>
      );

      return [...acc, listItem];
    }, []);

    setState(prev => ({ ...prev, list: newList }));
  }, [state.credits, isMobile]);

  // Archive Management
  const showArchive = useCallback(() => {
    if (state.slide) Event.emit("deposit_archive_back");

    setState(prev => ({ ...prev, slide: !prev.slide }));

    wait(300).then(() => {
      setState(prev => ({ ...prev, deposit: !prev.deposit }));
    });

    wait(300).then(() => {
      loadCoinId("BTC");
    });
  }, [state.slide]);

  // Coin Loading and Management
  const loadCoinId = useCallback(async (coin) => {

    const coinsList = [
      { id: "WWT", symbol: "WWT" },
      { id: "ethereum", symbol: "ETH" },
      { id: "tether-usdt", symbol: "USDT" },
      { id: "bitcoincash", symbol: "BCH" },
      { id: "litecoin", symbol: "LTC" },
      { id: "tron", symbol: "TRX" },
      { id: "dogecoin", symbol: "DOGE" },
      { id: "cardano", symbol: "ADA" },
      { id: "ripple", symbol: "XRP" },
      { id: "binancecoin", symbol: "BNB" },
      { id: "paxdollar", symbol: "USDP" },
      { id: "nexo", symbol: "NEXO" },
      { id: "maker", symbol: "MKR" },
      { id: "trueusd", symbol: "TUSD" },
      { id: "usdcoin", symbol: "USDC" },
      { id: "binanceusd", symbol: "BUSD" },
    ];

    // console.log("coin name", coin)
    if (coin.toUpperCase() === 'INR') {
      // console.log("Coin is INR, skipping loadCoinId process.");
      return;
    }

    setState(prev => ({
      ...prev,
      currentCoin: coin,
      coinId: "",
      networks: [],
      selectedNetwork: "",
      isLoading: true,
      coinName: "",
      logoUrl: ""
    }));

    // console.log("coin", coin)

    try {
      const token = storage.getKey('token');

      // Check if token exists before making the API call
      if (!token) {
        console.log('🔐 No token found, skipping coin details fetch');
        setState(prev => ({ ...prev, isLoading: false }));
        return;
      }

      console.log('🔐 Fetching coin details with token:', !!token);

      const response = await axios.post('https://api.ibitplay.com/getCoinDetails',
        { symbol: coin.toUpperCase() },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      // console.log("infor", response)
      const { coinId, networks, coinFullName, logoUrl } = response.data;
      let networksList = Object.keys(networks);

      // console.log("netweok liss", networksList)

      const coinInfo = coinsList.find(item => item.symbol === coin.toUpperCase());
      let selectedNetwork = networksList[0] || "";
      // let coinName = coinInfo ? coinInfo.id : coin.toLowerCase();


      let coinName = coinInfo ? coinInfo.id : coin.toLowerCase();
      // // Special handling for USDT
      // if (coin.toUpperCase() === 'USDT') {
      //     networksList = ['ETH', 'TRX', 'BSC']; // Only allow these networks for USDT
      // }
      // Update coin name dynamically based on selected network for all coins
      switch (selectedNetwork) {
        case 'USDT':
          coinName = 'tether-usdt';
        case 'TRX':
          coinName = 'tron'; // For TRX network
          break;
        case 'BSC':
          coinName = 'binancecoin'; // For BSC network
          break;
        case 'ETH':
          coinName = 'ethereum'; // For ETH network
          break;
        case 'BTC':
          coinName = 'bitcoin'; // For BTC network
          break;
        case 'BCH':
          coinName = 'bitcoincash'; // For BCH network
          break;
        case 'ADA':
          coinName = 'cardano'; // For ADA network
          break;
        case 'XRP':
          coinName = 'ripple'; // For XRP network
          break;
        case 'DOGE':
          coinName = 'dogecoin'; // For DOGE network
          break;
        case 'LTC':
          coinName = 'litecoin'; // For LTC network
          break;
        case 'USDP':
          coinName = 'paxdollar'; // For USDP network
          break;
        case 'NEXO':
          coinName = 'nexo'; // For NEXO network
          break;
        case 'MKR':
          coinName = 'maker'; // For MKR network
          break;
        case 'TUSD':
          coinName = 'trueusd'; // For TUSD network
          break;
        case 'USDC':
          coinName = 'usdcoin'; // For USDC network
          break;
        case 'BUSD':
          coinName = 'binanceusd'; // For BUSD network
          break;
        default:
          coinName = coinInfo ? coinInfo.id : coin.toLowerCase(); // Fallback to default
          break;
      }


      // console.log("network list", networksList);
      // console.log("name", coinName)
      setSelctedNetwork(networksList[0])

      setState(prev => ({
        ...prev,
        coinId,
        networks: networksList,
        selectedNetwork,
        isLoading: false,
        coinName,
        logoUrl
      }));
    } catch (error) {
      console.error("Error fetching coin details:", error);

      if (error.response?.status === 401) {
        console.log('🔐 401 Unauthorized for coin details');
        // Handle unauthorized access gracefully
        setState(prev => ({ ...prev, isLoading: false }));
        return;
      }

      // sendNotfication("Error fetching coin information", "error", "top-right");
      setState(prev => ({ ...prev, isLoading: false }));
    }
  }, [getCoinNameByNetwork]);


  const [ccInitiate, setCCInititate] = useState(false)
  // Payment Processing
  const initiateDeposit = async () => {
    if (!state.amount || state.amount <= 0) {
      sendNotfication("Please enter a correct amount.", "error", "top-right");
      return;
    }

    if (!selectedNetwork) {
      sendNotfication("Please Choose Network.", "error", "top-right");
      return;
    }
    setCCInititate(true)

    setState(prev => ({ ...prev, isLoading: true, qrString: "" }));
    const payload = {
      coinId: state.coinId,
      price: state.amount,
      orderId: `order${Date.now()}`,
      chain: selectedNetwork,
      generateCheckoutURL: true,
      returnUrl: "https://api.ibitplay.com/",
      userid: getUID().toString()
    }

    // console.log("paylod", payload)

    const token = getAuthToken();
    try {
      const response = await axios.post('https://api.ibitplay.com/createDeposit', payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${storage.getKey('token')}`
        },
      }


      );

      const { data } = response.data;

      if (data.address) {

        // Determine correct coin name based on the selected network
        let coinName;
        switch (state.selectedNetwork.toUpperCase()) {
          case 'USDT':
            coinName = 'tether-usdt';  // For TRX network
            break;
          case 'TRX':
            coinName = 'tron';  // For TRX network
            break;
          case 'ETH':
            coinName = 'ethereum';  // For ETH network
            break;
          case 'BSC':
            coinName = 'binancecoin';  // For BSC network
            break;
          case 'BTC':
            coinName = 'bitcoin';  // For BTC network
            break;
          case 'BCH':
            coinName = 'bitcoincash';  // For BCH network
            break;
          case 'ADA':
            coinName = 'cardano';  // For ADA network
            break;
          case 'XRP':
            coinName = 'ripple';  // For XRP network
            break;
          case 'DOGE':
            coinName = 'dogecoin';  // For DOGE network
            break;
          case 'LTC':
            coinName = 'litecoin';  // For LTC network
            break;
          case 'USDP':
            coinName = 'paxdollar';  // For USDP network
            break;
          case 'NEXO':
            coinName = 'nexo';  // For NEXO network
            break;
          case 'MKR':
            coinName = 'maker';  // For MKR network
            break;
          case 'TUSD':
            coinName = 'trueusd';  // For TUSD network
            break;
          case 'USDC':
            coinName = 'usdcoin';  // For USDC network
            break;
          case 'BUSD':
            coinName = 'binanceusd';  // For BUSD network
            break;
          default:
            coinName = state.coinName;  // Use current coin name if no match
            break;
        }

        // console.log("data us", data)

        setState(prev => ({
          ...prev,
          depositAddress: data.address,
          depositAmount: state.amount,
          showDepositDetails: true,
          isLoading: false,
          qrString: `${data.address}`
        }));
      } else {
        sendNotfication("Deposit initiation failed", "error", "top-right");
        setState(prev => ({ ...prev, isLoading: false }));
        setCCInititate(false);
      }
    } catch (error) {
      console.error("Error initiating deposit:", error);
      sendNotfication("Error initiating deposit", "error", "top-right");
      setState(prev => ({ ...prev, isLoading: false }));
      setCCInititate(false);
    }
  };


  // Socket Connection Effect
  useEffect(() => {
    const token = storage.getKey('token');

    if (token) {
      socket.emit(C.CREDIT, encode({ coin: selectedCoin === 'USD' ? 'USDT' : selectedCoin }));
    }

    const handleCreditData = (data) => {
      const decodedData = decode(data);
      const { credit } = decodedData;
      setCredits(credit);

      const currentCoin = __.lowerCase(selectedCoin);
      const currentCredit = forceSatoshiFormat(credit[currentCoin]);
      storage.setKey('credit', currentCredit);
    };

    const handleCreditUpdate = (data) => {
      const decodedData = decode(data);
      const { value, coin: updatedCoin } = decodedData;
      const formattedValue = forceSatoshiFormat(value);

      setCredits(prev => ({
        ...prev,
        [__.lowerCase(updatedCoin)]: value
      }));

      if (__.lowerCase(updatedCoin) === __.lowerCase(selectedCoin)) {
        storage.setKey('credit', formattedValue);
      }
    };

    socket.on(C.CREDIT, handleCreditData);
    socket.on(C.UPDATE_CREDIT, handleCreditUpdate);

    return () => {
      socket.off(C.CREDIT, handleCreditData);
      socket.off(C.UPDATE_CREDIT, handleCreditUpdate);
    };
  }, [selectedCoin]);

  // Initial Setup Effect
  useEffect(() => {
    const storedCoin = storage.getKey('coin') || "BTC";
    socket.emit(C.CREDIT, encode({ coin: storedCoin === 'USD' ? 'USDT' : storedCoin }));
    socket.on(C.CREDIT, (data) => getCreditAndCoins(decode(data)));

    socket.on("deposit_archive", showArchive);

    wait(400).then(() => {
      loadCoinId(storage.getKey('coin') || "BTC");
    });

    return () => {
      socket.off(C.CREDIT);
    };
  }, [storage.getKey('coin') || "BTC", getCreditAndCoins, loadCoinId, showArchive]);

  // USER_INFO Effect - fetch user info on mount
  useEffect(() => {
    const handleUserInfo = (raw) => {
      const data = decode(raw);
      if (data) {
        setUserInfo(data);
        if (data.name) {
          setCustomerName(data.name);
        }
        if (data.email) {
          setCustomerEmail(data.email);
        }
        if (data.phone) {
          setPhoneNumber(data.phone);
        }
      }
    };

    socket.on(C.USER_INFO, handleUserInfo);

    const token = storage.getKey('token');
    if (token) {
      socket.emit(C.USER_INFO, encode({
        id: getUID(),
        coin: storage.getKey('coin') || 'BTC',
        rate: null,
        game: 'all',
        first: true
      }));
    }

    return () => {
      socket.off(C.USER_INFO, handleUserInfo);
    };
  }, []);

  // Sync selectedCoin with SkylaCredit via coin_changed event
  useEffect(() => {
    const handleCoinChanged = (coinName) => {
      setSelectedCoin(coinName);
      setState(prev => ({ ...prev, currentCoin: coinName }));
      loadCoinId(coinName);
    };

    socket.on('coin_changed', handleCoinChanged);

    // Initialize with USD
    setSelectedCoin("USD");
    setState(prev => ({ ...prev, currentCoin: "USD" }));
    loadCoinId("USD");


  }, [loadCoinId]);

  // Active Coins Initialization Effect
  useEffect(() => {
    if (!storage.getKey('active_coins')) {
      const defaultActiveCoins = ['1', '2', '3', '4', '5', '6', '7'];
      storage.setKey('active_coins', defaultActiveCoins.join(','));
      setActiveCoins(defaultActiveCoins);
    }
  }, []);

  // Click Outside Handler Effect
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.dropdown-container')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  const handleCoinSelect = async (coinName) => {
    setSelctedNetwork('')
    setState(prev => ({
      ...prev,

      coinId: "",
      networks: [],
      selectedNetwork: "",

      coinName: "",
      logoUrl: ""
    }));
    setCCInititate(false)

    storage.setKey('coin', coinName);
    const creditKey = coinName === 'USD' ? 'usdt' : __.lowerCase(coinName);
    const credit = forceSatoshiFormat(credits[creditKey] || 0);
    storage.setKey('credit', credit);

    setSelectedCoin(coinName);
    loadCoinId(coinName)
    setIsOpen(false);

    try {
      await wait(200);
      Event.emit('coin_changed', coinName);
    } catch (error) {
      console.error('Error during coin selection:', error);
    }
  };

  // Show all coins (except BJT and SC), filtered by search, regardless of activeCoins
  const filteredCoins = coins
    .filter(coin => {
      if (coin.preffix === 'BJT' || coin.preffix === 'SC') return false;
      return coin.preffix.toLowerCase().includes(searchTerm.toLowerCase());
    })
    .sort((a, b) => {
      if (a.preffix === 'BTC') return -1;
      if (b.preffix === 'BTC') return 1;
      return 0;
    });

  const selectedCoinData = coins.find(coin => coin.preffix === selectedCoin);
  //statically netwrosk added later will remove it
  const networkDetails = [
    "Etherum", "BEP20"
  ]
  const handleUPISelect = (upiType) => {
    setSelectedUPI(upiType);
    // Additional logic for UPI selection can be added here
  };
  const handleUPI1Payment = async () => {



    if (!state.amount || parseFloat(state.amount) < 300) {
      sendNotfication("Please enter an amount equal to or greater than ₹300.", "error", "top-right");
      return;
    }

    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const response = await axios.post('https://api.ibitplay.com/remotes/create-deposit',

        {
          amount: state.amount,
          currency: 'INR',
          custom_user_id: getUID(),
          custom_transaction_id: `TX_${Date.now()}`,
          payment_system: "phonepe",
          webhook_id: 2472417,
          return_url: 'https://api.ibitplay.com',
        }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${storage.getKey('token')}`
        },
      });

      const { success, url, order_id } = response.data;

      if (success) {
        setState(prev => ({
          ...prev,
          depositAmount: state.amount,
          orderId: order_id,
          isLoading: false,
          iframeUrl: url, // Store the URL for iframe
          showIframe: true // Show the iframe
        }));

      } else {
        sendNotfication("Payment initiation failed", "error", "top-right");
      }
    } catch (error) {
      console.error("Error initiating INR payment:", error);
      if (!state.amount || parseFloat(state.amount) < 300) {
        sendNotfication("Please enter amount equal to or greater than ₹300.", "error", "top-right");
      } else {
        sendNotfication(error.message, "error", "top-right");
      }
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const handleIMPSPayment = async () => {
    if (!state.amount || parseFloat(state.amount) < 300) {
      sendNotfication("Please enter an amount equal to or greater than ₹300.", "error", "top-right");
      return;
    }

    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const response = await axios.post('https://api.ibitplay.com/remotes/create-deposit', {
        amount: state.amount,
        currency: 'BDT',
        custom_user_id: getUID(),
        custom_transaction_id: `TX_${Date.now()}`,
        payment_system: "imps",
        webhook_id: 2472417,
        return_url: 'https://api.ibitplay.com',
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${storage.getKey('token')}`
        },
      });

      const { success, url, order_id } = response.data;

      if (success) {

        setState(prev => ({
          ...prev,
          depositAmount: state.amount,
          orderId: order_id,
          isLoading: false,
          iframeUrl: url, // Store the URL for iframe
          showIframe: true // Show the iframe
        }));

      } else {
        sendNotfication("Payment initiation failed", "error", "top-right");
      }
    } catch (error) {
      console.error("Error initiating INR payment:", error);
      if (!state.amount || parseFloat(state.amount) < 300) {
        sendNotfication("Please enter amount equal to or greater than ₹300.", "error", "top-right");
      } else {
        sendNotfication(error.message, "error", "top-right");
      }
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };



  const handleUPI3Payment = async () => {
    if (!state.amount || parseFloat(state.amount) < 1000) {
      sendNotfication("Please enter an amount equal to or greater than ₹1000.", "error", "top-right");
      return;
    }

    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const name = localStorage.getItem("name");
      let id = getUID();
      const response = await axios.post('https://api.ibitplay.com/cricpay/payment-request', {
        amount: state.amount,
        userId: id,
        paymentMethod: "PS002",
        userName: "jhonSon"
      });


      const { status, accessURL, transactionCode } = response.data;

      if (status === "Success") {

        setState(prev => ({
          ...prev,
          depositAmount: state.amount,
          orderId: transactionCode,
          isLoading: false,
          iframeUrl: accessURL, // Store the URL for iframe
          showIframe: true // Show the iframe
        }));

      } else {
        sendNotfication("Payment initiation failed", "error", "top-right");
      }
    } catch (error) {
      console.error("Error initiating INR payment:", error);
      if (!state.amount || parseFloat(state.amount) < 1000) {
        sendNotfication("Please enter amount equal to or greater than ₹1000.", "error", "top-right");
      } else {
        sendNotfication(error.message, "error", "top-right");
      }
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const handleNetBankingPayment = async () => {
    if (!state.amount || parseFloat(state.amount) < 1000) {
      sendNotfication("Please enter an amount equal to or greater than ₹1000.", "error", "top-right");
      return;
    }

    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const name = localStorage.getItem("name");
      let id = getUID();
      const response = await axios.post('https://api.ibitplay.com/cricpay/payment-request', {
        amount: state.amount,
        userId: id,
        paymentMethod: "PS003",
        userName: "jhonSon"
      });

      const { status, accessURL, transactionCode } = response.data;

      if (status === "Success") {

        setState(prev => ({
          ...prev,
          depositAmount: state.amount,
          orderId: transactionCode,
          isLoading: false,
          iframeUrl: accessURL, // Store the URL for iframe
          showIframe: true // Show the iframe
        }));

      } else {
        sendNotfication("Payment initiation failed", "error", "top-right");
      }
    } catch (error) {
      console.error("Error initiating INR payment:", error);
      if (!state.amount || parseFloat(state.amount) < 1000) {
        sendNotfication("Please enter amount equal to or greater than ₹1000.", "error", "top-right");
      } else {
        sendNotfication(error.message, "error", "top-right");
      }
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };
  const [upiMethod, setUpiMethod] = useState('f2pay');

  const handleF2PayPayment = async () => {
    if (!state.amount || parseFloat(state.amount) < 100) {
      sendNotfication("Please enter an amount equal to or greater than ₹100.", "error", "top-right");
      return;
    }
    if (!phoneNumber || phoneNumber.length < 10) {
      sendNotfication("Please enter a valid phone number.", "error", "top-right");
      return;
    }
    if (!customerName.trim()) {
      sendNotfication("Please enter your name.", "error", "top-right");
      return;
    }
    if (!customerEmail.trim()) {
      sendNotfication("Please enter your email.", "error", "top-right");
      return;
    }

    setState(prev => ({ ...prev, isLoading: true }));
    try {
      const token = getAuthToken();
      if (!token) {
        sendNotfication("Please login first.", "error", "top-right");
        setState(prev => ({ ...prev, isLoading: false }));
        return;
      }

      const response = await axios.post('https://api.ibitplay.com/f2pay/createOrder', {
        amount: state.amount,
        customerName: customerName.trim(),
        customerPhone: phoneNumber,
        customerEmail: customerEmail.trim(),
        subject: "Deposit",
        body: "Deposit via F2Pay",
        methodCode: "UpiMixed",
        user_id: getUID(),
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      const { success, payUrl, paymentUrl, orderNo } = response.data;
      const redirectUrl = payUrl || paymentUrl;

      if (success && redirectUrl) {
        setState(prev => ({
          ...prev,
          depositAmount: state.amount,
          orderId: orderNo,
          isLoading: false,
          iframeUrl: redirectUrl,
          showIframe: true
        }));
      } else {
        sendNotfication("Payment initiation failed", "error", "top-right");
        setState(prev => ({ ...prev, isLoading: false }));
      }
    } catch (error) {
      const errMsg = error.response?.data?.error || error.message || "Error initiating payment";
      sendNotfication(errMsg, "error", "top-right");
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const handleCashAppPayment = async () => {
    if (!state.amount || parseFloat(state.amount) <= 0) {
      sendNotfication("Please enter a valid amount.", "error", "top-right");
      return;
    }
    if (!cashAppEmail.trim()) {
      sendNotfication("Please enter your email.", "error", "top-right");
      return;
    }

    setState(prev => ({ ...prev, isLoading: true }));
    try {
      const token = storage.getKey('token');
      if (!token) {
        sendNotfication("Please login first.", "error", "top-right");
        setState(prev => ({ ...prev, isLoading: false }));
        return;
      }

      const response = await axios.post('https://api.ibitplay.com/cashApp/createOrder', {
        amount: parseFloat(state.amount),
        email: cashAppEmail.trim(),
        productName: cashAppProductName.trim() || "Deposit",
        user_id: getUID().toString(),
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      const data = response.data;
      const redirectUrl = data.payUrl || data.paymentUrl || data.url || data.redirect_url || data.redirectUrl || data.payment_url || data.link;
      setState(prev => ({ ...prev, isLoading: false }));
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        sendNotfication(data.message || "Payment initiation failed", "error", "top-right");
      }
    } catch (error) {
      const errMsg = error.response?.data?.error || error.response?.data?.message || error.message || "Error initiating Cash App payment";
      sendNotfication(errMsg, "error", "top-right");
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const handleUPI2Payment = async () => {
    // console.log(`Proceeding with UPI2 and phone ${phoneNumber}`);
    console.log(`Proceeding with UPI2 payment method`);

    if (!state.amount || parseFloat(state.amount) < 100) {
      sendNotfication("Please enter an amount equal to or greater than ₹200.", "error", "top-right");
      return;
    }



    setState(prev => ({ ...prev, isLoading: true }));
    const token = getAuthToken();

    // Check if token exists before making the API call
    if (!token) {
      console.log('🔐 No token found, skipping bonus config fetch');
      setBonusConfig([]);
      return;
    }

    try {
      const response = await axios.post('https://api.ibitplay.com/api/payments/payin/initiate', {
        userId: getUID(),
        currency: "INR",
        out_trade_no: `TX${Date.now()}`,
        pay_type: "UPI",
        money: state.amount,
        attach: "",
        notify_url: "https://api.ibitplay.com/api/payments/payin/callback",
        returnUrl: "https://air1bet.com",
        phone: phoneNumber
      },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });

      const { code, data } = response.data;

      if (code === 0) {
        setState(prev => ({
          ...prev,
          depositAmount: state.amount,
          orderId: data.transaction_Id,
          isLoading: false,
          iframeUrl: data.url, // Store the URL for iframe
          showIframe: true // Show the iframe
        }));
      } else {
        sendNotfication("Payment initiation failed", "error", "top-right");
      }
    } catch (error) {
      console.error("Error initiating UPI payment:", error);
      if (!state.amount || parseFloat(state.amount) < 100) {
        sendNotfication("Please enter amount equal to or greater than ₹100.", "error", "top-right");
      } else {
        sendNotfication("Error initiating UPI payment");
      }
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const handleSubmitTransactionFiat = async () => {
    if (!transactionId || !screenshot) {
      setError("Please fill all required fields");
      return;
    }

    if (!state.amount || parseFloat(state.amount) <= 0) {
      setError("Please enter a valid amount");
      return;
    }

    try {
      const formData = new FormData();

      // Use the fields required by your API
      formData.append('user_id', getUID());
      formData.append('amount', state.amount);
      formData.append('transaction_id', transactionId);
      formData.append('screenshot', screenshot);
      formData.append('currency', selectedCoin);
      // Add bank details if selected payment is Bank Transfer
      if (selectedPayment === "Bank Transfer") {
        formData.append('bank_name', selectedBank);
        formData.append('account_number', selectedBankDetails.accountNumber);
        formData.append('account_holder_name', selectedBankDetails.accountName);
      }
      // Add UPI details if selected payment is UPI
      else if (selectedPayment === "UPI ID") {
        formData.append('upi_id', '993939393@upi');
      }

      // Debug logging - similar to backend
      console.log('Starting deposit creation process:', {
        body: {
          user_id: getUID(),
          amount: state.amount,
          transaction_id: transactionId,
          currency: selectedCoin,
          bank_name: selectedPayment === "Bank Transfer" ? selectedBank : 'N/A',
          account_number: selectedPayment === "Bank Transfer" ? selectedBankDetails.accountNumber : 'N/A',
          account_holder_name: selectedPayment === "Bank Transfer" ? selectedBankDetails.accountName : 'N/A'
        },
        file: screenshot ? 'File present' : 'No file'
      });

      const response = await axios.post('https://api.ibitplay.com/api/deposits/create', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${storage.getKey('token')}`
        }
      });

      if (response.data.success) {
        sendNotfication("Deposit request created successfully", "success", "top-right");
        setShowTransactionForm(false);
        setTransactionId("");
        setScreenshot(null);
        setCCInititate(false);
        setState(prev => ({ ...prev, amount: "" }));
      }
    } catch (error) {
      console.error("Error submitting transaction:", error);
      setError("Failed to submit deposit request");
    }
  };
  const handleDeposit = () => {
    if (!state.amount) {
      setError("Please enter deposit amount");
      return;
    }

    // Only support BDT and INR currencies with manual payment flow
    if (selectedCoin === 'INR' || selectedCoin === 'BDT') {
      setShowTransactionForm(true);
    } else {
      setError("Only INR and BDT currencies are supported");
    }

    // Comment out other payment methods for now
    // if (isFiatCurrency(selectedCoin)) {
    //   if (paymentMode === 'automatic' && selectedCoin === 'INR') {
    //     // Use existing automatic payment for INR
    //     handleUPI1Payment();
    //   } else {
    //     // For all other fiat currencies or manual INR payments, 
    //     // show transaction form for manual payments
    //     setShowTransactionForm(true);
    //   }
    // } else {
    //   // For crypto deposits
    //   initiateDeposit();
    // }
  };
  const renderINRSpecificFields = () => {
    // Only support BDT and INR currencies with manual payment flow
    // if (selectedCoin === 'INR' || selectedCoin === 'BDT') {
    //   return (
    //     <DepositButton
    //       onClick={() => {
    //         setShowTransactionForm(true);
    //         setCCInititate(true);
    //       }}
    //     >
    //       Proceed to Payment
    //     </DepositButton>
    //   );
    // }

    // Comment out other payment methods for now
    if (selectedCoin === 'INR') {
      return (
        <PaymentMethodContainer>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '16px', marginTop: '10px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#fff', cursor: 'pointer', fontSize: '14px' }}>
                  <input
                    type="radio"
                    name="paymentMethodModal"
                    checked={upiMethod === 'f2pay'}
                    onChange={() => setUpiMethod('f2pay')}
                    style={{ accentColor: '#FF5C5C', width: '18px', height: '18px' }}
                  />
                  Payment Method 1
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#fff', cursor: 'pointer', fontSize: '14px' }}>
                  <input
                    type="radio"
                    name="paymentMethodModal"
                    checked={upiMethod === 'upi2'}
                    onChange={() => setUpiMethod('upi2')}
                    style={{ accentColor: '#FF5C5C', width: '18px', height: '18px' }}
                  />
                    Payment Method 2
                </label>
                {/* <label style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#fff', cursor: 'pointer', fontSize: '14px' }}>
                  <input
                    type="radio"
                    name="paymentMethodModal"
                    checked={upiMethod === 'upi1'}
                    onChange={() => setUpiMethod('upi1')}
                    style={{ accentColor: '#FF5C5C', width: '18px', height: '18px' }}
                  />
                   Payment Method 3
                </label> */}

              </div>

              {upiMethod === 'upi2' && (
                <Input
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="Enter Phone Number"
                  style={{ marginTop: '10px' }}
                />
              )}
              {upiMethod === 'f2pay' && (
                <>
                  <Input
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    placeholder="Enter Your Name"
                    style={{ marginTop: '10px' }}
                  />
                  <Input
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="Enter Phone Number"
                    style={{ marginTop: '10px' }}
                  />
                  <Input
                    value={customerEmail}
                    onChange={(e) => setCustomerEmail(e.target.value)}
                    placeholder="Enter Email Address"
                    style={{ marginTop: '10px' }}
                  />
                </>
              )}

          <DepositButton
              onClick={upiMethod === 'upi1' ? handleUPI1Payment : upiMethod === 'f2pay' ? handleF2PayPayment : handleUPI2Payment}
            >
              Proceed to Payment
            </DepositButton>
        </PaymentMethodContainer>
      );
    } else if (isFiatCurrency(selectedCoin)) {
      return (
        <DepositButton
          onClick={() => {
            setShowTransactionForm(true);
            setCCInititate(true);
          }}
        >
          Proceed to Payment
        </DepositButton>
      );
    } else if (selectedCoin === 'USD') {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <DepositButton
            onClick={() => setShowCashAppForm(!showCashAppForm)}
            style={{ background: 'linear-gradient(135deg, #00D632 0%, #00B82B 100%)' }}
          >
            Payment Via Cash App
          </DepositButton>
          {showCashAppForm && (
            <div style={{ borderTop: '1px solid #2a3439', paddingTop: '10px', marginTop: '5px' }}>
              <div style={{ color: '#aaa', fontSize: '13px', marginBottom: '8px' }}>Cash App Payment Details</div>
              <Input
                value={state.amount}
                onChange={(e) => setState(prev => ({ ...prev, amount: e.target.value }))}
                placeholder="Enter Amount"
                style={{ marginBottom: '8px' }}
              />
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                <span style={{ color: '#aaa', fontSize: '13px', minWidth: '80px' }}>User ID:</span>
                <span style={{ color: '#fff', fontSize: '14px' }}>{getUID()}</span>
              </div>
              <Input
                value={cashAppEmail}
                onChange={(e) => setCashAppEmail(e.target.value)}
                placeholder="Enter Email Address"
                style={{ marginBottom: '8px' }}
              />
              <Input
                value={cashAppProductName}
                readOnly
                placeholder="Product Name"
                style={{ marginBottom: '8px', opacity: 0.7, cursor: 'not-allowed' }}
              />
              <DepositButton
                onClick={handleCashAppPayment}
                style={{ background: 'linear-gradient(135deg, #00D632 0%, #00B82B 100%)' }}
              >
                Proceed with Cash App
              </DepositButton>
            </div>
          )}
        </div>
      );
    } else {
      // For crypto currencies
      return (

        <DepositButton onClick={initiateDeposit}>
          Proceed with Deposit
        </DepositButton>

      );
    }
  };


  const FIAT_CURRENCIES = {
    INR: {
      payType: 'UPI',
      automatic: true,
      manual: true
    },
    MVR: {
      payType: 'Bank',
      automatic: false,
      manual: true
    },
    PKR: {
      payType: 'Bank',
      automatic: false,
      manual: true
    },
    AED: {
      payType: 'Bank',
      automatic: false,
      manual: true
    },
    BDT: {
      payType: 'Bank',
      automatic: false,
      manual: true
    }
  };

  const isFiatCurrency = (currency) => {
    return Object.keys(FIAT_CURRENCIES).includes(currency);
  };

  // Add an effect to listen for coin_changed events
  useEffect(() => {
    const handleCoinChanged = (coinName) => {
      setSelectedCoin(coinName);
      loadCoinId(coinName);
    };

    Event.on('coin_changed', handleCoinChanged);

    // Initialize with USD
    setSelectedCoin("USD");
    loadCoinId("USD");

    return () => {
      // Event.off('coin_changed', handleCoinChanged);
    };
  }, [loadCoinId]);

  // --- Bonus Card State ---
  const [bonusConfig, setBonusConfig] = useState([]);
  const [selectedBonusType, setSelectedBonusType] = useState('casino');
  const [showBonusInfoModal, setShowBonusInfoModal] = useState(false);

  // Fetch bonus config on mount only if token exists

  useEffect(() => {
    const token = getAuthToken();
    if (token) {
      console.log('🔐 Token found, fetching bonus config');
      fetchBonusConfig();
    } else {
      console.log('🔐 No token found, skipping bonus config fetch');
      setBonusConfig([]);
    }
  }, []);

  const fetchBonusConfig = async () => {
    try {
      const token = getAuthToken();

      // Check if token exists before making the API call
      if (!token) {
        console.log('🔐 No token found, skipping bonus config fetch');
        setBonusConfig([]);
        return;
      }

      console.log('🔐 Fetching bonus config with token:', !!token);

      const response = await fetch('https://api.ibitplay.com/api/bonus/config-public', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 401) {
        console.log('🔐 401 Unauthorized for bonus config');
        setBonusConfig([]);
        return;
      }

      const data = await response.json();
      console.log('✅ Bonus config loaded successfully');
      setBonusConfig(data);
    } catch (error) {
      console.error('❌ Error fetching bonus config:', error);
      setBonusConfig([]);
    }
  };


  // const bonus = bonusConfig.find(b => b.bonus_type === selectedBonusType) || {};
  // const casinoBonus = bonusConfig.find(b => b.bonus_type === 'casino') || {};
  // const sportsBonus = bonusConfig.find(b => b.bonus_type === 'sports') || {};

  // Casino Card
  const CasinoCard = (
    <BonusCardContainer
      className={selectedBonusCard === 'casino' ? 'selected' : ''}
      onClick={() => setSelectedBonusCard('casino')}
    ><BonusSVGWrapper>
        <SmallImagePlaceholder src="/assets/images/bonus/wheel.webp" alt="Casino Bonus" />
      </BonusSVGWrapper>

      <BonusCardSectionTitle>Casino Bonus</BonusCardSectionTitle>
      <InfoIconButton onClick={e => { e.stopPropagation(); setShowCasinoInfo(true); }}>
        <InfoIcon size={16} />
      </InfoIconButton>

      {/* <BonusCardInfo>...</BonusCardInfo> */}
      {showCasinoInfo && (
        <BonusInfoModalOverlay onClick={() => setShowCasinoInfo(false)}>
          <BonusInfoModalContent onClick={e => e.stopPropagation()}>
            <BonusInfoModalClose onClick={() => setShowCasinoInfo(false)}>&times;</BonusInfoModalClose>

            <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 18 }}>Casino Bonus</div>
            <ul style={{ paddingLeft: 0, listStyle: 'none', color: '#fff', fontSize: 16 }}>
              <li style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
                <span style={{ color: '#FF5C5C', marginRight: 10, fontSize: 18 }}>•</span>
                Enjoy a 300% bonus on your casino deposit
              </li>
              <li style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
                <span style={{ color: '#FF5C5C', marginRight: 10, fontSize: 18 }}>•</span>
                Minimum deposit required: $10
              </li>
              <li style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
                <span style={{ color: '#FF5C5C', marginRight: 10, fontSize: 18 }}>•</span>
                Wagering requirement: 30x the bonus amount
              </li>
              <li style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
                <span style={{ color: '#FF5C5C', marginRight: 10, fontSize: 18 }}>•</span>
                Available on selected slot and table games
              </li>
              <li style={{ marginBottom: 0, display: 'flex', alignItems: 'center' }}>
                <span style={{ color: '#FF5C5C', marginRight: 10, fontSize: 18 }}>•</span>
                Claimable once per user per promotion
              </li>
            </ul>
          </BonusInfoModalContent>
        </BonusInfoModalOverlay>
      )}
    </BonusCardContainer>
  );

  // Sports Card
  const SportsCard = (
    <BonusCardContainer
      className={selectedBonusCard === 'sports' ? 'selected' : ''}
      onClick={() => setSelectedBonusCard('sports')}
    >
      <BonusSVGWrapper>
        <SmallImagePlaceholder src="/assets/images/bonus/cup-1.webp" alt="Sports Bonus" />
      </BonusSVGWrapper>

      <BonusCardSectionTitle>Sports Bonus</BonusCardSectionTitle>
      <InfoIconButton onClick={e => { e.stopPropagation(); setShowSportsInfo(true); }}>
        <InfoIcon size={16} />
      </InfoIconButton>

      {/* <BonusCardInfo>...</BonusCardInfo> */}
      {showSportsInfo && (
        <BonusInfoModalOverlay onClick={() => setShowSportsInfo(false)}>
          <BonusInfoModalContent onClick={e => e.stopPropagation()}>
            <BonusInfoModalClose onClick={() => setShowSportsInfo(false)}>&times;</BonusInfoModalClose>
            <div style={{ fontWeight: 700, fontSize: 22, marginBottom: 18 }}>Sports Bonus</div>

            <ul style={{ paddingLeft: 0, listStyle: 'none', color: '#fff', fontSize: 16 }}>
              <li style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
                <span style={{ color: '#FF5C5C', marginRight: 10, fontSize: 18 }}>•</span>
                Get a 300% bonus on your sports deposit
              </li>
              <li style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
                <span style={{ color: '#FF5C5C', marginRight: 10, fontSize: 18 }}>•</span>
                Minimum deposit required: $10
              </li>
              <li style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
                <span style={{ color: '#FF5C5C', marginRight: 10, fontSize: 18 }}>•</span>
                Wagering requirement: 30x the bonus amount
              </li>
              <li style={{ marginBottom: 12, display: 'flex', alignItems: 'center' }}>
                <span style={{ color: '#FF5C5C', marginRight: 10, fontSize: 18 }}>•</span>
                Available for all registered users
              </li>
              <li style={{ marginBottom: 0, display: 'flex', alignItems: 'center' }}>
                <span style={{ color: '#FF5C5C', marginRight: 10, fontSize: 18 }}>•</span>
                Applies to selected sports betting markets
              </li>
            </ul>
          </BonusInfoModalContent>
        </BonusInfoModalOverlay>
      )}
    </BonusCardContainer>
  );

  const BonusCards = (
    <BonusCardsWrapper>
      {CasinoCard}
      {SportsCard}
    </BonusCardsWrapper>
  );

  // Add state to control bonus card visibility
  const [showBonusCards, setShowBonusCards] = useState(false);

  // Add a Get Bonus button handler
  const handleGetBonusClick = () => setShowBonusCards((prev) => !prev);

  return (
    <Container>


      <TokenListContainer>
        {tokens.map(token => (
          <TokenButton key={token.id}>
            <TokenIcon src={token.icon} alt={`${token.name} icon`} />
            <TokenName>{token.name}</TokenName>
          </TokenButton>
        ))}
      </TokenListContainer>
      {/* 
      <FooterText>
        Didn't see your currency? <AddLink>Add here</AddLink>
      </FooterText> */}

      {
        paymentMode === "automatic" && selectedCoin === "INR" ? (<div style={{ display: "flex", gap: "5px", width: "100%" }}>
          <div style={{ flex: '1' }}>
            <div style={{ color: "#B3BEC1", margin: "4px 0" }}>Deposit Currency</div>
            <DropdownContainer>
              <DropdownButton onClick={(e) => {
                e.stopPropagation();
                setIsOpen(!isOpen);
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <CoinImage
                    src={`/assets/images/${selectedCoinData?.image}`}
                    alt={selectedCoin}
                  />
                  <CoinName>{selectedCoin}</CoinName>
                </div>
                <ChevronDown size={20} />
              </DropdownButton>

              {isOpen && (
                <DropdownPanel onClick={e => e.stopPropagation()}>
                  <SearchContainer>
                    <SearchIcon>
                      <Search size={20} />
                    </SearchIcon>
                    <SearchInput
                      placeholder="Search coins..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      autoFocus
                    />
                  </SearchContainer>

                  {filteredCoins.map((coin) => (
                    <CoinOption
                      key={coin.id}
                      onClick={() => handleCoinSelect(coin.preffix)}
                      isSelected={selectedCoin === coin.preffix}
                    >
                      <CoinImage src={`/assets/images/${coin.image}`} alt={coin.preffix} />
                      <CoinName>{coin.preffix}</CoinName>
                      <CoinBalance>
                        {forceSatoshiFormat(credits[__.lowerCase(coin.preffix)] || 0)}
                      </CoinBalance>
                    </CoinOption>
                  ))}
                </DropdownPanel>
              )}
            </DropdownContainer>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'left', margin: '16px 0' }}>
              <DepositButton style={{ maxWidth: 150 }} onClick={handleGetBonusClick}>
                {showBonusCards ? 'Get Bonus' : 'Get Bonus'}
              </DepositButton>
            </div>
            {showBonusCards && BonusCards}
          </div>
        </div>) : (
          <div style={{ display: "flex", gap: "5px", width: "100%" }}>
            <div style={{ flex: '1' }}>
              <div style={{ color: "#B3BEC1", margin: "4px 0" }}>Deposit Currency</div>
              <DropdownContainer>
                <DropdownButton onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen(!isOpen);
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <CoinImage
                      src={`/assets/images/${selectedCoinData?.image}`}
                      alt={selectedCoin}
                    />
                    <CoinName>{selectedCoin}</CoinName>
                  </div>
                  <ChevronDown size={20} />
                </DropdownButton>

                {isOpen && (
                  <DropdownPanel onClick={e => e.stopPropagation()}>
                    <SearchContainer>
                      <SearchIcon>
                        <Search size={20} />
                      </SearchIcon>
                      <SearchInput
                        placeholder="Search coins..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        autoFocus
                      />
                    </SearchContainer>

                    {filteredCoins.map((coin) => (
                      <CoinOption
                        key={coin.id}
                        onClick={() => handleCoinSelect(coin.preffix)}
                        isSelected={selectedCoin === coin.preffix}
                      >
                        <CoinImage src={`/assets/images/${coin.image}`} alt={coin.preffix} />
                        <CoinName>{coin.preffix}</CoinName>
                        <CoinBalance>
                          {forceSatoshiFormat(credits[__.lowerCase(coin.preffix)] || 0)}
                        </CoinBalance>
                      </CoinOption>
                    ))}
                  </DropdownPanel>
                )}
              </DropdownContainer>
            </div>

            {
              isFiatCurrency(selectedCoin) ? (

                <div style={{ flex: '1' }}>
                  {/* Show for other fiat and crypto coins as usual */}
                  <>
                    <div style={{ color: "#B3BEC1", margin: "4px 0" }}>
                      {isFiatCurrency(selectedCoin) ? "Choose Bank" : "Choose Network"}
                    </div>
                    <DropdownContainer>
                      <DropdownButton
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsOpenNetwork(!isOpenNetwork);
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          {bankImage && (
                            <div style={{ width: '24px', height: '24px', borderRadius: '50%', overflow: 'hidden' }}>
                              <QRImageComponent qrImage={bankImage} alt="Selected Bank QR" />
                            </div>
                          )}
                          <CoinName>{selectedBank || (isFiatCurrency(selectedCoin) ? "Select Bank" : "Select Network")}</CoinName>
                        </div>
                        <ChevronDown size={20} />
                      </DropdownButton>

                      {isOpenNetwork && (
                        <DropdownPanel onClick={(e) => e.stopPropagation()}>
                          {bankDetails.map((bank) => (
                            <CoinOption
                              key={bank.id}
                              onClick={() => handleBankSelect(bank.bank_name)}
                              isSelected={selectedBank === bank.bank_name}
                            >
                              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                {bank.qr_image && (
                                  <div style={{ width: '24px', height: '24px', borderRadius: '50%', overflow: 'hidden' }}>
                                    <QRImageComponent qrImage={bank.qr_image} alt={`${bank.bank_name} QR`} />
                                  </div>
                                )}
                                <CoinName>{bank.bank_name}</CoinName>
                              </div>
                            </CoinOption>
                          ))}
                        </DropdownPanel>
                      )}
                    </DropdownContainer>
                  </>

                </div>

              ) :
                (
                  <>
                    {
                      state.networks?.length > 0 && (
                        <div style={{ flex: '1' }}>
                          <div style={{ color: "#B3BEC1", margin: "4px 0" }}>
                            Choose Network
                          </div>
                          <DropdownContainer>
                            <DropdownButton
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsOpenNetwork(!isOpenNetwork);
                              }}
                            >
                              <CoinName>{selectedNetwork}</CoinName>
                              <ChevronDown size={20} />
                            </DropdownButton>

                            {isOpenNetwork && (
                              <DropdownPanel onClick={e => e.stopPropagation()}>
                                {state?.networks?.map((network) => (
                                  <CoinOption
                                    key={network}
                                    onClick={() => {
                                      setSelctedNetwork(network)
                                      setIsOpenNetwork(false);
                                    }}
                                    isSelected={selectedNetwork === network}
                                  >
                                    <CoinName>{network}</CoinName>
                                  </CoinOption>
                                ))}
                              </DropdownPanel>
                            )}
                          </DropdownContainer>
                        </div>
                      )
                    }
                  </>
                )
            }
          </div>
        )
      }
      <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>

      </div>

      {
        state?.isLoading ?
          <SpinnerWrapper className="p-4">
            <Spinner />
            <LoadingText>Loading</LoadingText>
          </SpinnerWrapper>
          : (
            <>

              {
                ccInitiate && (
                  <CodeContainer>
                    {isFiatCurrency(selectedCoin) ? (
                      <>
                        <QRCodeContainer>
                          {selectedCoin === "INR" && selectedBankDetails.qr_image ? (
                            <QRImageComponent qrImage={selectedBankDetails.qr_image} alt="Bank QR Code" />
                          ) : selectedCoin === "INR" ? (
                            <img
                              src="data:image/png;base64,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"
                              alt="QR Code"
                            />
                          ) : null}
                        </QRCodeContainer>


                        <ContentContainer>
                          {/* <Label>
                            {selectedBank ? `${selectedBank} Bank Details` : "Bank Details"}
                          </Label> */}

                          {selectedBankDetails?.accountName && (
                            <AddressContainer>
                              <span>Account Holder Name: {selectedBankDetails.accountName}</span>
                              <CopyButton
                                onClick={() => handleCopyAddress('accountName', selectedBankDetails.accountName)}
                                copied={copiedStates.accountName}
                              >
                                {copiedStates.accountName ? <CheckCircle size={18} /> : <Copy size={18} />}
                              </CopyButton>
                            </AddressContainer>
                          )}

                          {selectedBankDetails?.accountNumber && (
                            <AddressContainer>
                              <span>Account Number: {selectedBankDetails.accountNumber}</span>
                              <CopyButton
                                onClick={() => handleCopyAddress('accountNumber', selectedBankDetails.accountNumber)}
                                copied={copiedStates.accountNumber}
                              >
                                {copiedStates.accountNumber ? <CheckCircle size={18} /> : <Copy size={18} />}
                              </CopyButton>
                            </AddressContainer>
                          )}

                          {selectedBankDetails?.ifscCode && (
                            <AddressContainer>
                              <span>IFSC Code: {selectedBankDetails.ifscCode}</span>
                              <CopyButton
                                onClick={() => handleCopyAddress('ifscCode', selectedBankDetails.ifscCode)}
                                copied={copiedStates.ifscCode}
                              >
                                {copiedStates.ifscCode ? <CheckCircle size={18} /> : <Copy size={18} />}
                              </CopyButton>
                            </AddressContainer>
                          )}

                          {selectedBankDetails?.upiId && (
                            <AddressContainer>
                              <span>UPI ID: {selectedBankDetails.upiId}</span>
                              <CopyButton
                                onClick={() => handleCopyAddress('upiId', selectedBankDetails.upiId)}
                                copied={copiedStates.upiId}
                              >
                                {copiedStates.upiId ? <CheckCircle size={18} /> : <Copy size={18} />}
                              </CopyButton>
                            </AddressContainer>
                          )}
                        </ContentContainer>
                      </>
                    ) : (
                      <>
                        <QRCode
                          size={150}
                          logoWidth={150}
                          value={state.qrString}
                        />

                        <ContentContainer>
                          <Label>Deposit address</Label>
                          <AddressContainer>
                            <span>{state.depositAddress}</span>
                            <CopyButton onClick={handleCopy}>
                              {copied ? <CheckCircle size={18} /> : <Copy size={18} />}
                            </CopyButton>
                          </AddressContainer>
                        </ContentContainer>
                      </>
                    )}
                  </CodeContainer>
                )
              }
            </>
          )
      }
      <div style={{ display: "flex", gap: "10px", width: "100%", flexDirection: 'column', marginTop: "10px" }}>
        {selectedCoin !== 'USD' && (
          <Input
            value={state.amount}
            onChange={(e) => {
              const newAmount = e.target.value;
              setState((prev) => ({ ...prev, amount: newAmount }));

              // Clear error when input changes
              setError("");

              // Check for MVR minimum amount while typing
              if (state.currentCoin === "MVR" && newAmount !== "" && Number(newAmount) < 100) {
                setError("Minimum deposit for MVR is 100");
              }
            }}
            placeholder={placeholder}
          />
        )}
        {error && <ErrorText>{error}</ErrorText>}
        {renderINRSpecificFields()}

        {showTransactionForm ? (
          <TransactionForm>
            <Input
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
              placeholder="Enter Transaction/UTR Number"
            />
            <FileUploadContainer onClick={() => document.getElementById('fileInput').click()}>
              <Upload size={24} color="#41ED84" />
              <UploadText>{screenshot ? screenshot.name : 'Upload Payment Screenshot'}</UploadText>
              <input
                id="fileInput"
                type="file"
                accept="image/*"
                onChange={handleFileUpload}
                style={{ display: 'none' }}
              />
            </FileUploadContainer>
            <DepositButton onClick={handleSubmitTransactionFiat}>
              Submit
            </DepositButton>
          </TransactionForm>
        ) : (
          !isFiatCurrency(selectedCoin) && (
            // <DepositButton onClick={handleDeposit}>
            //   {selectedCoin === 'MVR' ? 'Proceed to Payment' : 'Deposit'}
            // </DepositButton>
            <div></div>
          )
        )}
      </div>


      {isOpenBonus && (
        <RadioContainer>
          {deposits.map((deposit, index) => (
            <Label3 key={index}>
              <RadioWrapper>
                <HiddenRadio
                  type="radio"
                  name="deposit"
                  value={deposit}
                  checked={selectedDeposit === deposit}
                  onChange={(e) => setSelectedDeposit(e.target.value)}
                />
                <CustomRadio />
              </RadioWrapper>
              <Text>{deposit}<span style={{ color: "rgb(67,236,131)", fontFamily: 'none', marginLeft: '4px', fontSize: '14px', fontWeight: 'bold' }}>{getTextBonus(index)}</span></Text>
            </Label3>
          ))}
        </RadioContainer>
      )}
      <div style={{ margin: "12px 0" }}>
        <WarningContainer>
          <Info color="#ab1ac6" />
          <WarningText>Do not deposit any currency other than {selectedCoin}</WarningText>
        </WarningContainer>

        {/* Add the new note container right here */}
        <NoteContainer>
          <NoteIcon size={20} />
          <NoteText>
            Usually deposits are instant but in some cases {selectedCoin === "INR" ? "INR" : selectedCoin} deposits can take up to 2hrs.
            If you haven't received your deposit amount, please contact customer support.
          </NoteText>
        </NoteContainer>
      </div>
      {state.isLoading && (
        <PaymentProcessingOverlay>
          <ProcessingSpinner />
          <ProcessingTitle>Processing Your Deposit</ProcessingTitle>
          <ProcessingMessage>
            Please wait while we redirect you to the payment gateway. Do not close or refresh this page<ProcessingDots />
          </ProcessingMessage>
        </PaymentProcessingOverlay>
      )}

      {state.showIframe && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            zIndex: 1000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              width: '100%',
              maxWidth: '600px',
              height: '600px',
              backgroundColor: '#fff',
              borderRadius: '8px',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            <button
              onClick={() => {
                setState((prev) => ({ ...prev, showIframe: false, iframeUrl: '' }));
                window.location.reload();
              }}
              style={{
                position: 'absolute',
                top: '12px',
                left: '12px',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                border: 'none',
                borderRadius: '50%',
                padding: '10px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                transition: 'background-color 0.2s, transform  reman 0.2s',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 1)')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.9)')}
              onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(0.95)')}
              onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
              aria-label="Back"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#333"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <iframe
              src={state.iframeUrl}
              style={{ width: '100%', height: '100%', border: 'none' }}
              title="UPI Payment"
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
          </div>
        </div>
      )}

    </Container>
  );
};

export default SkylaDepositModal;



